import {
    LOADING_DATA_ADMIN,
    SET_DATA_ADMIN,
    SET_ERROR_ADMIN
} from '../types'

const initialState = {
    loadingadmin: false,
    admin: {},
    message: '',
    error: ''
}


export default function (state = initialState, action) {
    switch (action.type) {
        case LOADING_DATA_ADMIN:
            return {
                ...state,
                loadingadmin: true
            }
        case SET_DATA_ADMIN:
            return {
                loadingadmin: false,
                ...action.payload
            }
        case SET_ERROR_ADMIN:
            return {
                loadingadmin: false,
                ...action.payload
            }
        default: return state
    }
}